// extracted by mini-css-extract-plugin
module.exports = {"container":"ScreenSwiper_container__mDuIF","overflow":"ScreenSwiper_overflow__5BLMw"};